/**
 * Romanian leu.
 */
export var RON = {
  code: 'RON',
  base: 10,
  exponent: 2
};